import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderComponent} from "../../order-manager/order/order.component";
import {catchError, throwError} from "rxjs";
import {NotesService} from "../../../services-otc/notes.service";
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';

@Component({
    selector: 'app-edit-note',
    templateUrl: './edit-note.component.html',
    styleUrls: ['./edit-note.component.css'],
    standalone: false
})
export class EditNoteComponent {

  note: string = '';

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<OrderComponent>,
      private notesService: NotesService,
      public nav: NavBarComponent,
  ) {
  }

  ngOnInit(): void {
    this.note = this.data.note;
   }

   onInputChange(event: any): void {
    this.note = event.target.value;
  }


  cancelUpdatingNote(){
    this.dialogRef.close();
  }
  updateNewOrderNote() {
    this.nav.toggleLoading(true);
    if(this.data.orderId){
      let noteObj = {
        id: this.data.noteID,
        note: this.note,
        orderId: this.data.orderId
      };
    
      this.notesService.updateOrderNote(noteObj.id,noteObj.note, noteObj.orderId).pipe(
          catchError(error => {
            console.error(error);
            return throwError(() => error);
          })
      ).subscribe(() => {
        this.dialogRef.close();
        this.nav.toggleLoading(false);
      });
    }
  }

}
